export default __webpack_public_path__ + "static/media/twitter.3cda1785.svg";